import React, {useContext} from "react";
import TakeOffDetail from "../TakeOffDetail/TakeOffDetail";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import {useMatch} from "react-router-dom";

type Props = {};

export const TakeOffDetailWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const match = useMatch(`/take_offs/:guid`)

    return <div className={"TakeOffDetailWrapper"}>
        <TakeOffDetail
            socket={socket}
            toggleSidebar={uiContext.toggleSidebar}
            setSidebarComponent={uiContext.setSidebarComponent}
            setActivityIndicator={uiContext.setActivityIndicator}
            notifyFn={uiContext.notifyFn}
            userModel={userModel}
            supplierModel={supplierModel}
            match={match}
        />
    </div>;
};
